// Indian mobile validation — mirrors backend utils/phone.py.
export const MOBILE_ERROR = 'Mobile number must be exactly 10 digits (a +91 or 0 prefix is allowed).';

export const normalizeMobile = (raw) => {
  if (raw == null) return null;
  let s = String(raw).replace(/[\s\-().]/g, '');
  if (s.startsWith('+91')) s = s.slice(3);
  else if (s.startsWith('0')) s = s.slice(1);
  return /^\d{10}$/.test(s) ? s : null;
};

// Returns an error string, or null when the value is acceptable.
export const mobileError = (raw, { required = false } = {}) => {
  if (!raw || !String(raw).trim()) return required ? 'Mobile number is required.' : null;
  return normalizeMobile(raw) ? null : MOBILE_ERROR;
};
